module.exports = __webpack_public_path__ + "static/img/ok.f5b92d6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ok.png
// module id = ZDmO
// module chunks = 1